import React from 'react'
import formStyles from 'styles/form.module.scss'
import DeviceId from 'utils/detectDevice'
import { inputHasErr } from 'utils/validations'
import Dropdown from 'react-dropdown'
import useTracking from 'hooks/useTracking'

export const PostedBy = ({ options, meta, input }) => {
  const handleChange = useTracking('postedby')
  return (
    <div className={`form-group col-md-12 ${formStyles.formEleWrap}`}>
      <label htmlFor="profileFor" className={formStyles.layerLable}>
        Create Profile for
      </label>
      {DeviceId.isMobile() && (
        <select
          onBlur={handleChange()}
          className={`form-control ${inputHasErr(meta) &&
            formStyles.inputError} ${formStyles.selectMobile}`}
          {...input}
        >
          <option value="" hidden>
            Select
          </option>
          {options.map((option, index) => {
            return (
              <option value={option} key={index}>
                {option}
              </option>
            )
          })}
        </select>
      )}

      {DeviceId.isDesktop() && (
        <Dropdown
          onBlur={handleChange()}
          controlClassName="postedby_selector"
          menuClassName="postedby_options"
          options={options}
          value={options[0]}
          placeholder={'Select'}
          className={`${inputHasErr(meta) && formStyles.inputError}`}
          {...input}
        />
      )}

      {meta.touched && meta.error && (
        <p data-testid="postedby_error" className={formStyles.error}>
          {meta.error}
        </p>
      )}
    </div>
  )
}

export default PostedBy
